import { render } from "./FlightCard.vue?vue&type=template&id=164bc8eb"
import script from "./FlightCard.vue?vue&type=script&lang=js"
export * from "./FlightCard.vue?vue&type=script&lang=js"

import "./FlightCard.vue?vue&type=style&index=0&id=164bc8eb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__